import * as React from "react";
import Tooltip from "@warda/library-ui/core/Tooltip";
const CardContent = ({ classes, tooltip, children }) => {
    return (React.createElement(Tooltip, { title: tooltip },
        React.createElement("div", { className: classes.cardContent }, children)));
};
export default CardContent;
